var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X Social Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    width: 50,
    height: 50,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.8776 22.5857L36.1839 12H33.9782L25.8997 21.1911L19.4443 12H12L21.7603 25.9L12 37H14.2057L22.7382 27.2929L29.5557 37H37L26.8776 22.5857ZM23.8576 26.0214L22.8687 24.6375L14.9998 13.625H18.3874L24.7362 22.5125L25.7251 23.8964L33.98 35.45H30.5924L23.8576 26.0214Z",
    fill: "#1C1E2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterImg);
export default __webpack_public_path__ + "static/media/TwitterImg.4e2f5e8e710bc8a698851ab2d07ce69a.svg";
export { ForwardRef as ReactComponent };